export default "__VITE_ASSET__DdHrxUvq__"